import Immutable, { Map } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { RESET_STORE } from 'constants/index'

// constants
export const APPLICATION_FETCH_TABLE_DATA =
  'application/APPLICATION_FETCH_TABLE_DATA'
export const [
  APPLICATION_FETCH_TABLE_DATA_SUCCESS,
  APPLICATION_FETCH_TABLE_DATA_FAILURE,
] = [
  `${APPLICATION_FETCH_TABLE_DATA}_SUCCESS`,
  `${APPLICATION_FETCH_TABLE_DATA}_FAILURE`,
]
export const APPLICATION_DELETE = 'application/DELETE'
export const [APPLICATION_DELETE_SUCCESS, APPLICATION_DELETE_FAILURE] = [
  `${APPLICATION_DELETE}_SUCCESS`,
  `${APPLICATION_DELETE}_FAILURE`,
]
export const APPLICATION_CLEAR_STATE_LIST =
  'application/APPLICATION_CLEAR_STATE_LIST'
export const APPLICATION_CLEAR_STATE_FORM =
  'application/APPLICATION_CLEAR_STATE_FORM'
export const APPLICATION_CLEAR_STATE = 'application/CLEAR_STATE'
export const APPLICATION_CHANGE = 'application/APPLICATION_CHANGE'
export const APPLICATION_FETCH_FORM_DATA =
  'application/APPLICATION_FETCH_FORM_DATA'
export const [
  APPLICATION_FETCH_FORM_DATA_SUCCESS,
  APPLICATION_FETCH_FORM_DATA_FAILURE,
] = [
  `${APPLICATION_FETCH_FORM_DATA}_SUCCESS`,
  `${APPLICATION_FETCH_FORM_DATA}_FAILURE`,
]
export const APPLICATION_UPLOAD_ICON = 'application/APPLICATION_UPLOAD_ICON'
export const [
  APPLICATION_UPLOAD_ICON_SUCCESS,
  APPLICATION_UPLOAD_ICON_FAILURE,
] = [`${APPLICATION_UPLOAD_ICON}_SUCCESS`, `${APPLICATION_UPLOAD_ICON}_FAILURE`]

export const APPLICATION_UPLOAD_SMALL_ICON =
  'application/APPLICATION_UPLOAD_SMALL_ICON'
export const [
  APPLICATION_UPLOAD_SMALL_ICON_SUCCESS,
  APPLICATION_UPLOAD_SMALL_ICON_FAILURE,
] = [
  `${APPLICATION_UPLOAD_SMALL_ICON}_SUCCESS`,
  `${APPLICATION_UPLOAD_SMALL_ICON}_FAILURE`,
]

// actions
export const applicationFetchTableData = ActionHelper.createActionObj(
  APPLICATION_FETCH_TABLE_DATA,
)
export const applicationFetchFormData = ActionHelper.createActionObj(
  APPLICATION_FETCH_FORM_DATA,
)
export const applicationClearStateList = ActionHelper.createActionObj(
  APPLICATION_CLEAR_STATE_LIST,
)
export const applicationDelete = ActionHelper.createActionObj(
  APPLICATION_DELETE,
)
export const applicationClearState = ActionHelper.createActionObj(
  APPLICATION_CLEAR_STATE,
)
export const applicationClearStateForm = ActionHelper.createActionObj(
  APPLICATION_CLEAR_STATE_FORM,
)
export const applicationChange = ActionHelper.createActionObj(
  APPLICATION_CHANGE,
)
export const applicationUploadIcon = ActionHelper.createActionObj(
  APPLICATION_UPLOAD_ICON,
)
export const applicationUploadSmallIcon = ActionHelper.createActionObj(
  APPLICATION_UPLOAD_SMALL_ICON,
)

// store
const initialState = Immutable.fromJS({
  loading: true,
  applicationLoader: false,
  tableData: {
    data: [],
    count: 0,
  },
  formData: {},
})
const loadingActive = state => state.set('loading', true)

const application = handleActions(
  {
    [combineActions(
      APPLICATION_DELETE,
      APPLICATION_FETCH_TABLE_DATA_SUCCESS,
      APPLICATION_CHANGE,
    )]: loadingActive,
    [combineActions(APPLICATION_CLEAR_STATE, RESET_STORE)]: () => initialState,
    [APPLICATION_FETCH_TABLE_DATA_SUCCESS]: (state, action) =>
      state.set('tableData', Map(action.payload)),
    [APPLICATION_CLEAR_STATE_LIST]: state =>
      state.set('tableData', initialState.get('tableData')),
    [APPLICATION_FETCH_FORM_DATA_SUCCESS]: (state, action) =>
      state.set('formData', Map(action.payload)),
    [APPLICATION_CLEAR_STATE_FORM]: state =>
      state.set('formData', initialState.get('formData')),
    [combineActions(
      APPLICATION_UPLOAD_ICON,
      APPLICATION_UPLOAD_SMALL_ICON,
    )]: state => state.set('applicationLoader', true),
    [combineActions(
      APPLICATION_UPLOAD_ICON_SUCCESS,
      APPLICATION_UPLOAD_SMALL_ICON_SUCCESS,
    )]: (state, action) =>
      state
        .set('applicationLoader', false)
        .set('formData', Map(action.payload)),
    [combineActions(
      APPLICATION_UPLOAD_ICON_FAILURE,
      APPLICATION_UPLOAD_SMALL_ICON_FAILURE,
    )]: state => state.set('applicationLoader', false),
  },
  initialState,
)

export default application
